import type { Persona } from './mixpanel';

const ASSIST_PREFIXES = ['/insights', '/admin', '/assist'];
const SELF_CARE_PREFIXES = ['/self-care'];

export function classifyPersona(pathname: string): Persona | null {
  for (const prefix of ASSIST_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(prefix + '/')) return 'assist';
  }
  for (const prefix of SELF_CARE_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(prefix + '/')) return 'self_care';
  }
  return null;
}
